<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.66797 10.0013V6.66797C1.66797 4.31094 1.66797 3.13244 2.4002 2.4002C3.13244 1.66797 4.31094 1.66797 6.66797 1.66797H13.3346C15.6916 1.66797 16.8701 1.66797 17.6024 2.4002C18.3346 3.13244 18.3346 4.31094 18.3346 6.66797V10.0013C18.3346 12.3583 18.3346 13.5368 17.6024 14.2691C17.2055 14.6661 16.6774 14.8478 15.9015 14.931C15.8398 14.8477 15.7815 14.7821 15.7398 14.7364C15.643 14.63 15.5203 14.509 15.4013 14.3916L14.1571 13.1648L13.6977 12.6994C13.3957 10.9306 11.8559 9.58464 10.0014 9.58464C8.14681 9.58464 6.60697 10.9306 6.30502 12.6994L5.84556 13.1648L4.60147 14.3916C4.48246 14.5089 4.3597 14.6299 4.2629 14.7364C4.22126 14.7821 4.16288 14.8477 4.10122 14.931C3.32528 14.8478 2.79716 14.6661 2.4002 14.2691C1.66797 13.5368 1.66797 12.3583 1.66797 10.0013ZM7.5013 4.3763C7.15613 4.3763 6.8763 4.65613 6.8763 5.0013C6.8763 5.34648 7.15613 5.6263 7.5013 5.6263H12.5013C12.8465 5.6263 13.1263 5.34648 13.1263 5.0013C13.1263 4.65613 12.8465 4.3763 12.5013 4.3763H7.5013ZM5.20963 7.91797C5.20963 7.57279 5.48946 7.29297 5.83463 7.29297H14.168C14.5131 7.29297 14.793 7.57279 14.793 7.91797C14.793 8.26314 14.5131 8.54297 14.168 8.54297H5.83463C5.48946 8.54297 5.20963 8.26314 5.20963 7.91797Z"
      fill="currentColor"
    />
    <path
      d="M12.5 13.3359C12.5 14.7167 11.3807 15.8359 10 15.8359C8.61925 15.8359 7.5 14.7167 7.5 13.3359C7.5 11.9552 8.61925 10.8359 10 10.8359C11.3807 10.8359 12.5 11.9552 12.5 13.3359Z"
      fill="currentColor"
    />
    <path
      d="M7.50093 13.2671C7.50031 13.29 7.5 13.3129 7.5 13.3359C7.5 14.7167 8.61925 15.8359 10 15.8359C11.3807 15.8359 12.5 14.7167 12.5 13.3359C12.5 13.3129 12.4997 13.29 12.4991 13.2671C12.4626 11.9182 11.3577 10.8359 10 10.8359C8.70558 10.8359 7.64093 11.8197 7.51291 13.0804C7.50665 13.1419 7.50263 13.2043 7.50093 13.2671Z"
      fill="currentColor"
    />
    <path
      d="M6.39641 14.375L5.49602 15.2628C5.22596 15.5292 5.09094 15.6623 5.04421 15.7751C4.93774 16.032 5.02886 16.3171 5.26069 16.4523C5.36243 16.5115 5.54593 16.53 5.91294 16.567C6.12016 16.5878 6.22377 16.5983 6.31055 16.63C6.50482 16.7009 6.65596 16.8499 6.72787 17.0415C6.76 17.1271 6.77058 17.2293 6.79175 17.4336C6.82924 17.7955 6.84798 17.9764 6.90814 18.0768C7.04521 18.3054 7.33426 18.3953 7.59483 18.2903C7.70918 18.2442 7.84421 18.111 8.11427 17.8447L9.01458 16.953C7.75421 16.6107 6.75764 15.6275 6.39641 14.375Z"
      fill="currentColor"
    />
    <path
      d="M10.9883 16.953L11.8886 17.8447C12.1586 18.111 12.2937 18.2442 12.408 18.2903C12.6686 18.3953 12.9576 18.3054 13.0947 18.0768C13.1549 17.9764 13.1736 17.7955 13.2111 17.4336C13.2323 17.2293 13.2429 17.1271 13.2749 17.0415C13.3469 16.8499 13.498 16.7009 13.6923 16.63C13.7791 16.5983 13.8827 16.5878 14.0899 16.567C14.4569 16.53 14.6404 16.5115 14.7422 16.4523C14.974 16.3171 15.0651 16.032 14.9586 15.7751C14.9119 15.6623 14.7769 15.5292 14.5069 15.2628L13.6064 14.375C13.2452 15.6275 12.2486 16.6107 10.9883 16.953Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TccIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>